<template>
	<aside class="bb-nested-view">
		<section class="export-section">
			<span class="b360-form-label" role="heading">Export</span>
			<div class="export-card-container b360-grid-row">
				<a
					class="export-card b360-col-xs-12 b360-col-12"
					@click="downloadPPT()"
				>
					<span class="export-card-image">
						<font-awesome-icon :icon="['fal', 'cloud-download']" />
					</span>
					<span class="export-card-type">Download Presentation</span>
				</a>
			</div>
		</section>
	</aside>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import partnerPointsApi from '@/services/Lopp/partner-points-service';

export default {
	name: 'BbPptExport',
	components: {},
	computed: {
		...mapState({
			exportTypeArray: (state) => state.brandBuilderEditor.exportTypeArray,
			selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
		}),
		...mapGetters(['partnerPointsProfile', 'selectedDesignCampaignItem']),
	},
	methods: {
		downloadPPT() {
			const { campaignType, mediaType } = this.partnerPointsProfile();
			partnerPointsApi
				.toolboxAddPointsAsync(campaignType, mediaType, 'pptx')
				.finally(() => {
					/* Presentations will only have one variation for a selected design */
					window.open(this.selectedDesignCampaignItem[0].uri);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.export-card-container {
	@include rem(grid-gap, 10px);
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity $b360-motion-duration--shortest
		$b360-motion-easing--standard;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.export-card {
	display: flex;
	align-items: center;
	background-color: $off-white;
	border-radius: $b360-border-radius-base;
	border: $b360-border-width-thin $border-color-light solid;
	@include rem('padding', 9px 15pxpx);
	text-decoration: none;
	box-shadow: none;
	transition: $b360-motion-selection;
	cursor: pointer;

	&:hover {
		border-color: $b360-color--gray__medium;
		box-shadow: 0 0 6px $shadow-color;
	}
}

.export-card-image {
	@include rem('font-size', 26px);
	@include rem('margin-right', 16px);
	color: $brand-teal;
}

.export-card-type {
	font-size: $b360-font-size--base;
	color: $text-base-color;
	font-weight: 500;
}
</style>
